import { render, staticRenderFns } from "./DatesSchedule.vue?vue&type=template&id=61bdc414&scoped=true&"
import script from "./DatesSchedule.vue?vue&type=script&lang=js&"
export * from "./DatesSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bdc414",
  null
  
)

export default component.exports